module.exports = __webpack_public_path__ + "static/media/ip-licensing.31810d51.jpeg";